import { render } from "./NoDataTable.vue?vue&type=template&id=4f67191a"
import script from "./NoDataTable.vue?vue&type=script&lang=js"
export * from "./NoDataTable.vue?vue&type=script&lang=js"

import "./NoDataTable.vue?vue&type=style&index=0&id=4f67191a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__